define('home/views/CommentCardCollectionView',[
    'home/views/ActivityCardCollectionView',
    'home/views/CommentCardView',
], function (
    ActivityCardCollectionView,
    CommentCardView
) {
    'use strict';

    var CommentCardCollectionView = ActivityCardCollectionView.extend({
        itemView: CommentCardView,
    });

    return CommentCardCollectionView;
});

